import {
  FASTDOC_TEMPLACE_PRESET_IDENTIFIER,
  FastDocTemplatePreset,
} from './fastdoc';
import { SIDEBAR_ORDER_PRESET_IDENTIFIER, SidebarOrderPreset } from './sidebar';
import z from 'zod/v4';
import { DefaultPresetSchema } from './default-preset-schema';
import { ObjectValues } from '@/lib/utils';
import type { PresetConfig } from './types';
import type { ValueOf } from 'type-fest';
import { SUB_TENANT_PRESET_IDENTIFIER, SubTenantPreset } from './sub-tenant';
import {
  LISTING_QUEUE_TYPE_PRESET_IDENTIFIER,
  ListingQueueTypePreset,
} from './listing-queue-type';
import {
  LISTING_PUBLICATION_TEMPLATE_PRESET_IDENTIFIER,
  ListingPublicationTemplatePreset,
} from './listing-publication-template';
import {
  DW_REPORT_TEMPLATE_PRESET_IDENTIFIER,
  DwReportTemplatePreset,
} from './dw-report-template';
import {
  LISTING_CONTRACT_DRAFT_PRESET_IDENTIFIER,
  ListingContractDraftPreset,
} from './listing-contract-draft';

import {
  LISTING_VIEWING_DURATION_PRESET_IDENTIFIER,
  ListingViewingDurationPreset,
} from './listing-viewing-duration';
import {
  LISTING_STORAGE_CATEGORIES_PRESET_IDENTIFIER,
  ListingStorageCategoriesPreset,
} from './listing-storage-categories';

// Add identifiers here
export const PRESETS_IDENTIFIERS = {
  FASTDOC_TEMPLATE: FASTDOC_TEMPLACE_PRESET_IDENTIFIER,
  SIDEBAR_ORDER: SIDEBAR_ORDER_PRESET_IDENTIFIER,
  SUB_TENANT: SUB_TENANT_PRESET_IDENTIFIER,
  LISTING_QUEUE_TYPE: LISTING_QUEUE_TYPE_PRESET_IDENTIFIER,
  LISTING_PUBLICATION_TEMPLATE: LISTING_PUBLICATION_TEMPLATE_PRESET_IDENTIFIER,
  DW_REPORT_TEMPLATE: DW_REPORT_TEMPLATE_PRESET_IDENTIFIER,
  LISTING_CONTRACT_DRAFT: LISTING_CONTRACT_DRAFT_PRESET_IDENTIFIER,
  LISTING_VIEWING_DURATION: LISTING_VIEWING_DURATION_PRESET_IDENTIFIER,
  LISTING_STORAGE_CATEGORIES: LISTING_STORAGE_CATEGORIES_PRESET_IDENTIFIER,
} as const;

// Reference the presetConfig here
export const PRESETS = {
  [FASTDOC_TEMPLACE_PRESET_IDENTIFIER]: FastDocTemplatePreset,
  [SIDEBAR_ORDER_PRESET_IDENTIFIER]: SidebarOrderPreset,
  [SUB_TENANT_PRESET_IDENTIFIER]: SubTenantPreset,
  [LISTING_QUEUE_TYPE_PRESET_IDENTIFIER]: ListingQueueTypePreset,
  [LISTING_PUBLICATION_TEMPLATE_PRESET_IDENTIFIER]:
    ListingPublicationTemplatePreset,
  [DW_REPORT_TEMPLATE_PRESET_IDENTIFIER]: DwReportTemplatePreset,
  [LISTING_CONTRACT_DRAFT_PRESET_IDENTIFIER]: ListingContractDraftPreset,
  [LISTING_VIEWING_DURATION_PRESET_IDENTIFIER]: ListingViewingDurationPreset,
  [LISTING_STORAGE_CATEGORIES_PRESET_IDENTIFIER]:
    ListingStorageCategoriesPreset,
} as const satisfies Record<ValueOf<typeof PRESETS_IDENTIFIERS>, PresetConfig>;

export const PresetSchema = z.object({
  ...DefaultPresetSchema.shape,
  context: z.union(
    ObjectValues(PRESETS_IDENTIFIERS).map((value) => z.literal(value))
  ),
});

export type Preset = z.infer<typeof PresetSchema>;

export type AllPresets = typeof PRESETS;
export type GetPresetConfig<TKey extends keyof AllPresets> = AllPresets[TKey];

export type GetCurrentPresetSchema<TKey extends keyof AllPresets> = z.output<
  GetPresetConfig<TKey>['currentSchema']
> & { context: TKey };
